

import React from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { FaLock } from "react-icons/fa";
import { MdLocalOffer, MdRateReview, MdDriveFileMove } from "react-icons/md";
import Offers from './Offers';
import './home.css'
import ReviewLinks from './ReviewLinks';
import Referral from './Referral';
const Home = () => {
    return (
        <Tab.Container defaultActiveKey="offers">
            <h2 className='cmn_heading'>Home</h2>
            <div className='col-form-label-sm settingTabs gap-3 align-items-start'>
                <Nav variant="pills" className='w-100 bg-transparent shadow-none home-pills position-relative top-0 mb-2 gap-2'>

                    <Nav.Item>
                        <Nav.Link eventKey="offers"><MdLocalOffer size={20} /> Offers</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="reviewUs"><MdRateReview size={20} /> Review Us</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="referrals"><MdDriveFileMove size={20} /> Referrals</Nav.Link>
                    </Nav.Item>
                </Nav>

                <Tab.Content className='flex-grow-1'>

                    <Tab.Pane eventKey="offers">
                        <Offers />
                    </Tab.Pane>
                    <Tab.Pane eventKey="reviewUs">
                        <ReviewLinks />
                    </Tab.Pane>
                    <Tab.Pane eventKey="referrals">
                       <Referral/>
                    </Tab.Pane>
                </Tab.Content>
            </div>
        </Tab.Container>

    );
}

export default Home;